export default __webpack_public_path__ + "static/media/banner.8c3239d5.svg";